export interface ICombineByTransfersSort {
    id: string;
    fufDriveUri: string;
    typeId: string;
}

export type ICombineByTransfers = Omit<ICombineByTransfersSort, "id">;

export enum CheckPropertyErrors {
    NotSectionFound = "NotSectionFound",
    UnknownFormat = "UnknownFormat",
}

export type TransferTypes = CheckPropertyErrors | string;
